import { featureDefinitions } from "./definitions";
export function loadFeatures(features) {
    for (const key in features) {
        featureDefinitions[key] = {
            ...featureDefinitions[key],
            ...features[key],
        };
    }
}
//# sourceMappingURL=load-features.js.map